import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const getApiUrl = () => {
  const isServer = typeof window === "undefined";
  const isVercel = !!(
    process.env.NEXT_PUBLIC_VERCEL_ENV ||
    process.env.VERCEL_URL ||
    process.env.NEXT_PUBLIC_VERCEL_URL
  );

  if (isVercel) {
    // Vercel deployment
    if (isServer) {
      // Server-side on Vercel: use the deployed production URL
      return `https://${process.env.NEXT_PUBLIC_VERCEL_PROJECT_PRODUCTION_URL}/api-proxy`;
    } else {
      // Client-side on Vercel: use relative proxy
      return "/api-proxy";
    }
  }

  // Local development
  if (isServer) {
    // Server-side locally: use Docker service name for internal communication
    return process.env.NEXT_PUBLIC_API_URL ?? "http://backend:8000";
  } else {
    // Client-side locally: use localhost for external communication
    return "http://localhost:8001";
  }
};
